import { useCurrentTenant } from '@components/router/session-context';
import { rpx } from 'client/lib/rpx-client';
import { ModalForm } from '@components/modal-form';
import { Meeting } from 'server/types';
import { showError } from '@components/app-error';

interface Props {
  meeting: Pick<Meeting, 'id' | 'title'>;
  courseId: UUID;
  hasEnrolledStudents: boolean;
  onSuccess: () => void;
  hide(): void;
}

export function MoveToDraftsModal(props: Props) {
  const { terminology } = useCurrentTenant();

  async function moveToDraft() {
    try {
      await rpx.meetings.moveMeetingToDraft({
        courseId: props.courseId,
        id: props.meeting.id,
      });
      props.onSuccess();
    } catch (err) {
      showError(err);
    }
  }

  return (
    <ModalForm
      onClose={props.hide}
      onSubmit={moveToDraft}
      mode="warn"
      title={<>Move "{props.meeting.title}" to Drafts?</>}
      confirmButtonText="Move to Drafts"
    >
      <section class="flex flex-col gap-4">
        <p>This will unschedule the {terminology.meeting} and remove it from student calendars.</p>
      </section>
    </ModalForm>
  );
}
